<template>
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="side-menu"
        transform="translate(-32, -395)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <g
          id="communities_24dp_FILL1_wght400_GRAD0_opsz24"
          transform="translate(32, 395)"
        >
          <path
            id="community"
            d="M5.6,11.2 C6.04,11.2 6.41666667,11.0433333 6.73,10.73 C7.04333333,10.4166667 7.2,10.04 7.2,9.6 C7.2,9.16 7.04333333,8.78333333 6.73,8.47 C6.41666667,8.15666667 6.04,8 5.6,8 C5.16,8 4.78333333,8.15666667 4.47,8.47 C4.15666667,8.78333333 4,9.16 4,9.6 C4,10.04 4.15666667,10.4166667 4.47,10.73 C4.78333333,11.0433333 5.16,11.2 5.6,11.2 Z M10.4,11.2 C10.84,11.2 11.2166667,11.0433333 11.53,10.73 C11.8433333,10.4166667 12,10.04 12,9.6 C12,9.16 11.8433333,8.78333333 11.53,8.47 C11.2166667,8.15666667 10.84,8 10.4,8 C9.96,8 9.58333333,8.15666667 9.27,8.47 C8.95666667,8.78333333 8.8,9.16 8.8,9.6 C8.8,10.04 8.95666667,10.4166667 9.27,10.73 C9.58333333,11.0433333 9.96,11.2 10.4,11.2 Z M8,7.2 C8.44,7.2 8.81666667,7.04333333 9.13,6.73 C9.44333333,6.41666667 9.6,6.04 9.6,5.6 C9.6,5.16 9.44333333,4.78333333 9.13,4.47 C8.81666667,4.15666667 8.44,4 8,4 C7.56,4 7.18333333,4.15666667 6.87,4.47 C6.55666667,4.78333333 6.4,5.16 6.4,5.6 C6.4,6.04 6.55666667,6.41666667 6.87,6.73 C7.18333333,7.04333333 7.56,7.2 8,7.2 Z M8,16 C6.89333333,16 5.85333333,15.79 4.88,15.37 C3.90666667,14.95 3.06,14.38 2.34,13.66 C1.62,12.94 1.05,12.0933333 0.63,11.12 C0.21,10.1466667 0,9.10666667 0,8 C0,6.89333333 0.21,5.85333333 0.63,4.88 C1.05,3.90666667 1.62,3.06 2.34,2.34 C3.06,1.62 3.90666667,1.05 4.88,0.63 C5.85333333,0.21 6.89333333,0 8,0 C9.10666667,0 10.1466667,0.21 11.12,0.63 C12.0933333,1.05 12.94,1.62 13.66,2.34 C14.38,3.06 14.95,3.90666667 15.37,4.88 C15.79,5.85333333 16,6.89333333 16,8 C16,9.10666667 15.79,10.1466667 15.37,11.12 C14.95,12.0933333 14.38,12.94 13.66,13.66 C12.94,14.38 12.0933333,14.95 11.12,15.37 C10.1466667,15.79 9.10666667,16 8,16 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
